import WebSocketJSClass from "@/layout/webSocket";
import useGlobalModel from "@/model/globalModel";
import { CLIENT_APP_CODE, getBaseWSRequestUrl } from "@/utils/constants";
import { IMessagewarnlistDetail } from "@/views/messagewarn/messagewarnlistService";
import { useEffect, useRef, } from "react"

const instanceNotification = Notification || window.Notification;


/**
 * 消息类型
 */
interface IMsgType {
    type: "FRANCHISEE-MSG";
    data: IMessagewarnlistDetail;
}
/**
 * 心跳
 */
interface IMsgHeartBeatType {
    type: "HEART_BEAT";
    data: "pong";
}
/**
 * 连接创建成功
 */
interface IMsgCreateType {
    type: "START";
    data: "start";
}
/**
 * 异常
 */
interface IMsgErrorType {
    type: "ERROR";
    data: null;
}

/**
 * webSocket消息类型
 */
type IMsg = IMsgType | IMsgHeartBeatType | IMsgCreateType | IMsgErrorType


interface IUseToastNotification {
    jumpMsgDetail?: (data: IMessagewarnlistDetail) => void
    openNotification: (detail: IMessagewarnlistDetail) => void
}

export function useToastNotification(props: IUseToastNotification) {
    const {
        openNotification
    } = props;
    const { shopDs, user } = useGlobalModel();
    const wsRef = useRef<WebSocketJSClass>({} as WebSocketJSClass)

    useEffect(() => {
        // createWebSocket()
        // asyncLoadMagInit()
        // return () => {
        //     wsRef.current.Close()
        // }
    }, [])


    //创建ws
    const createWebSocket = () => {
        wsRef.current = new WebSocketJSClass(`${getBaseWSRequestUrl()}/msg/${CLIENT_APP_CODE}-${user.userCode}`, (data) => {
            let info: IMsg = data ? JSON.parse(data) : { type: "ERROR" }
            switch (info.type) {
                case "START":
                    return console.log("websocket创建成功:", info.data);
                case "HEART_BEAT":
                    return console.log("心跳回执:", info.data);
                case "ERROR":
                    return console.error("消息推送内容有误:", data);
                case "FRANCHISEE-MSG":
                    document.hidden ? creatNotification(info.data, info.data.subject || '') : openNotification(info.data);
                    break;
                default:
                    break;
            }
        })
        wsRef.current.createConnect()
    }

    /**
     * 消息通知授权初始化
     * @param detail 
     */
    const asyncLoadMagInit = () => {
        // console.log(instanceNotification);
        if (instanceNotification) {
            var permissionNow = instanceNotification.permission;
            if (permissionNow === 'granted') { //允许通知
                // creatNotification();
            } else if (permissionNow === 'default') {
                setPermission();
            } else if (permissionNow === 'denied') {
                console.log('用户拒绝了你!!!');
            } else {
                setPermission();
            }
        }

    }

    /**
     * 请求获取通知权限
     */
    function setPermission() {
        instanceNotification.requestPermission(function (PERMISSION) {
            if (PERMISSION === 'granted') {
                console.log('用户允许通知了!!!');
                // creatNotification();
            } else {
                console.log('用户拒绝了你!!!');
            }
        });
    }


    //   /**
    //    * 创建一个系统内部消息提示
    //    * @param placement 
    //    */
    //   const openNotification = (detail: IMessagewarnlistDetail, title: string) => {
    //       notification.info({
    //           message: title,
    //           description: <div></div>,
    //           placement: "bottomRight",
    //           duration: 120,
    //           style:{
    //             //   background: "#62f275"
    //           },
    //           key: detail.id,
    //           onClick: () => {
    //               jumpMsgDetail?.(detail)
    //               notification.close(detail.id)
    //           }
    //       });
    //       searchMsgUnreadNum?.()
    //   };

    /**
     * 创建一个消息通知
     * @param detail 
     * @returns 
     */
    function creatNotification(detail: IMessagewarnlistDetail, title: string) {
        if (!window.Notification) {
            alert("浏览器不支持通知！");
            return openNotification(detail);
        }
        console.log(window.Notification.permission);
        if (window.Notification.permission != 'granted') {
            console.log('用户未开启通知权限!!!');
            return openNotification(detail);
        }
        var instanceNotification = new Notification(title, {
            "body": "快点击处理吧!",
            "requireInteraction": true
        });
        instanceNotification.onshow = function () {
            console.log("显示通知");
        };
        instanceNotification.onclick = function (event) {
            event.preventDefault();
            //   jumpMsgDetail?.(detail)
            //   instanceNotification.close();
        };
        instanceNotification.onclose = function () {
            console.log("通知关闭");
        };
        instanceNotification.onerror = function () {
            console.log('错误');
        };
    }

    return {
        wsRef
    }
}